<template>
  <div>
    <v-row :justify="$vuetify.breakpoint.xs ? 'center' : 'end'" no-gutters class="mr-4">
      <v-col cols="auto" class="mt-2" @click="emitEvent" v-if="opcaoEditar && index !== 4">
        <icon name="paperclip" :size="20" style="cursor: pointer" tooltip="Anexar Documento" />
      </v-col>

      <v-col cols="auto" class="mt-2" @click="downloadRelatorio" v-if="index === 4">
        <icon name="download" :size="20" style="cursor: pointer" tooltip="Baixar" />
      </v-col>
    </v-row>
    <div v-if="index === 0" style="height: 100%">
      <DadosCadastrais ref="dadosCadastrais" @validate="changeStep" @complete="emitComplete" />
    </div>
    <div v-if="index === 1" style="height: 100%">
      <Classificacao ref="classificacao" @validate="changeStep" @complete="emitComplete" />
    </div>
    <div v-if="index === 2" style="height: 100%; width: 880px">
      <Hierarquia @complete="emitComplete" />
    </div>
    <div v-if="index === 3" style="height: 100%">
      <Endereco ref="endereco" @complete="emitComplete" />
    </div>
    <div v-if="index === 4" style="height: 100%">
      <Contato ref="contato" @complete="emitComplete" />
    </div>
    <overlay-loading v-model="loading" />

    <error-modal v-model="showError" :errObj="errObj" />
  </div>
</template>

<script>
import DadosCadastrais from './ViewDadosCadastrais'
import Classificacao from './Classificacao'
import Hierarquia from './Hierarquia'
import Endereco from './Endereco'
import Contato from './Contato'
import { EventBus } from '@/services/EventBus/EventBus'
import ExportarArquivo from '@/services/ExportarArquivo'
import Relatorios from '@/services/Relatorios/Relatorios'

const reader = new FileReader()

export default {
  components: {
    DadosCadastrais,
    Classificacao,
    Hierarquia,
    Endereco,
    Contato
  },
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showModalAnexo: false,
      loading: false,
      showError: false,
      errObj: {},
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      tokenBearer: localStorage.getItem('tokenBearer')
    }
  },
  methods: {
    async promiseGeneric(className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.setError(err)
      }
    },
    setError(err) {
      if (err.response) {
        this.loading = false
        this.errObj.status = err.response.status
        if (err.response.data instanceof Blob) {
          console.error(err.response.data)
          reader.readAsText(err.response.data)
        } else {
          this.showError = true
          this.errObj.error = err.response.data.message
        }
        document.documentElement.style.overflow = 'hidden'
      }

      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement.result
        this.errObj.error = JSON.parse(text).message
        this.showError = true
      })

      throw err
    },
    emitEvent() {
      EventBus.$emit('showAnexo', 'Dados Cadastrais')
    },
    async downloadRelatorio() {
      const args = this.getParametrosRelatorio()
      this.loading = true

      const relatorioService = new Relatorios(this.tokenBearer, this.$appConfig.config.API)
      const response = await this.promiseGeneric(relatorioService, 'exportar', args)

      const exportar = new ExportarArquivo(response)
      exportar.arquivo()

      this.loading = false
    },
    getParametrosRelatorio() {
      const parametros = new URLSearchParams()

      parametros.append('formatoRelatorio', 'XLSX')
      parametros.append('tipoRelatorio', 'RELATORIO_CONTATOS_UNIMED')
      parametros.append('unimedsId', this.$idUnimed)

      return parametros
    },
    emitComplete() {
      this.$emit('complete')
    },
    async validarMudanca() {
      switch (this.index) {
        case 0:
          return this.$refs.dadosCadastrais.validarMudanca()
        case 1:
          return this.$refs.classificacao.validarMudanca()
        case 3:
          return this.$refs.endereco.validarMudanca()
        default:
          return true
      }
    },
    async salvarVersao() {
      switch (this.index) {
        case 0:
          return this.$refs.dadosCadastrais.validateForm()

        case 1:
          return this.$refs.classificacao.validateForm()

        case 4:
          return this.$refs.contato.validateForm()

        default:
          return true
      }
    },
    changeStep(validator) {
      if (validator === true) {
        this.$emit('changeIndex')
      }
    }
  }
}
</script>
